const orderData = [
  {
    id: "order-001",
    createdAt: "2026-09-10",
    currency: "GBP",
    totalAmount: 471,
    productName: "Casual Shoes",
    quantity: 3,
    buyerName: "Luis Semedo",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 0777 5GB",
    shippingAddress: ["56a Exeter Road", "Exmouth", "EX8 1PY"],
    status: "已送到",
  },
  {
    id: "order-002",
    createdAt: "2026-09-10",
    currency: "GBP",
    totalAmount: 511,
    productName: "Casual Shoes",
    quantity: 3,
    buyerName: "Nick Millerchip",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 0808 7GB",
    shippingAddress: ["3 Flagstaff Green", "Gosport", "PO12 1GG"],
    status: "已送到",
  },
  {
    id: "order-003",
    createdAt: "2026-09-10",
    currency: "GBP",
    totalAmount: 839,
    productName: "Casual Shoes",
    quantity: 5,
    buyerName: "Aaron Roberts",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 0899 7GB",
    shippingAddress: ["12 Stephen St", "Milford haven", "SA73 2BY"],
    status: "已送到",
  },
  {
    id: "order-004",
    createdAt: "2026-09-10",
    currency: "GBP",
    totalAmount: 800,
    productName: "Casual Shoes",
    quantity: 5,
    buyerName: "Chris Howe",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 0959 5GB",
    shippingAddress: ["1 cherry tree", "Woodbridge", "IP12 4B"],
    status: "已送到",
  },
  {
    id: "order-005",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 1598,
    productName: "Casual Shoes",
    quantity: 9,
    buyerName: "Karen Stratton",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 0980 8GB",
    shippingAddress: ["331a Princess park manor", "London", "N11 3GX"],
    status: "已送到",
  },
  {
    id: "order-006",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 930,
    productName: "Casual Shoes",
    quantity: 5,
    buyerName: "Lauren McGregor",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1013 4GB",
    shippingAddress: ["80 Madison Close", "Hayle", "TR27 4BZ"],
    status: "已送到",
  },
  {
    id: "order-007",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 280,
    productName: "Casual Shoes",
    quantity: 1,
    buyerName: "Tim Ajakaiye",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1057 6GB",
    shippingAddress: ["53 Elgar Street", "London", "SE16 7QR"],
    status: "已送到",
  },
  {
    id: "order-008",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 829,
    productName: "Casual Shoes",
    quantity: 5,
    buyerName: "Loki Levey",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1103 8GB",
    shippingAddress: ["29 West Street", "Storrington", "RH20 4DZ"],
    status: "已送到",
  },
  {
    id: "order-009",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 692,
    productName: "Casual Shoes",
    quantity: 4,
    buyerName: "Dylan Westacott",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1170 0GB",
    shippingAddress: [
      "3 Limekilns Close Cinderford",
      "Gloucestershire",
      "GL14 3GE",
    ],
    status: "已送到",
  },
  {
    id: "order-010",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 490,
    productName: "Casual Shoes",
    quantity: 3,
    buyerName: "Tom Treadwell",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1206 4GB",
    shippingAddress: ["35 brynmorgrug", "Swansea", "SA8 3DG"],
    status: "已送到",
  },
  {
    id: "order-011",
    createdAt: "2026-09-09",
    currency: "GBP",
    totalAmount: 467,
    productName: "Casual Shoes",
    quantity: 3,
    buyerName: "Jack Fuller",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1241 3GB",
    shippingAddress: ["123 bellingdon road", "Chesham", "HP5 2HG"],
    status: "已送到",
  },
  {
    id: "order-012",
    createdAt: "2026-09-08",
    currency: "GBP",
    totalAmount: 785,
    productName: "Casual Shoes",
    quantity: 4,
    buyerName: "Ian dempsey",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1269 6GB",
    shippingAddress: ["47 spensley road", "Bedford", "MK45 5LQ"],
    status: "已送到",
  },
  {
    id: "order-013",
    createdAt: "2026-09-08",
    currency: "GBP",
    totalAmount: 983,
    productName: "Casual Shoes",
    quantity: 6,
    buyerName: "Scott Robbins",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1415 3GB",
    shippingAddress: ["9 Westfield close", "Hanham", "BS15 3SB"],
    status: "已送到",
  },
  {
    id: "order-014",
    createdAt: "2026-09-08",
    currency: "GBP",
    totalAmount: 530,
    productName: "Casual Shoes",
    quantity: 3,
    buyerName: "Trisha Birch",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1452 0GB",
    shippingAddress: ["Knoydart Lodge", "Mallaig", "PH41 4PL"],
    status: "已送到",
  },
  {
    id: "order-015",
    createdAt: "2026-09-08",
    currency: "GBP",
    totalAmount: 1305,
    productName: "Casual Shoes",
    quantity: 7,
    buyerName: "Ian Harfoot",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1510 5GB",
    shippingAddress: [
      "7 Gleabland place st athan",
      "St athan",
      "CF62 4PQ",
    ],
    status: "已送到",
  },
  {
    id: "order-016",
    createdAt: "2026-09-08",
    currency: "GBP",
    totalAmount: 732,
    productName: "Casual Shoes",
    quantity: 4,
    buyerName: "Laura Haynes",
    buyerCountry: "GB",
    carrier: "Royal Mail",
    trackingNumber: "MZ 5523 1556 0GB",
    shippingAddress: ["45 Cobham close", "London", "EN1 3SD"],
    status: "已送到",
  },
];

// The source workbook does not include a SKU, so each imported order is given
// a stable footwear catalogue reference in source-row order.
const orderProductIds = [
  21, 22, 23, 24, 29, 30, 31, 32, 33, 34, 43, 44, 45, 46, 47, 48,
];

const ordersWithProducts = orderData.map((order, index) => ({
  ...order,
  productId: orderProductIds[index],
}));

export default ordersWithProducts;
